import { merge, isNil } from 'lodash'

export default class LanguageModel {
  static _instance = null
  static get instance() {
    return LanguageModel._instance
  }

  static init(languageJson) {
    LanguageModel._instance = new LanguageModel()
    LanguageModel.instance.language = merge({}, languageJson, window.FPD.lang)
  }

  static lookup(key, defaultValue) {
    if(isNil(LanguageModel.instance)) {
      throw new Error('LanguageModel not initalized.')
    }
    return LanguageModel.instance.lookup(key, defaultValue)
  }
  
  static getLanguageUrl(optionsManager) {
    let languageUrl = `${optionsManager.fpdAdminUrl}/api/hosted/site_languages/?shop_domain=${optionsManager.shopifyDomain}`
    if(optionsManager.isNoCache()) {
      languageUrl += `&no_cache=1`
    }
    return languageUrl
  }

  constructor() {
    this._language = {}
  }

  get language() {
    return this._language
  }

  set language(language) {
    this._language = language
  }

  lookup(key, defaultValue) {
    return this.language[key] || defaultValue
  }
}
